
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStackedClosedLeft as ObiTwowayStackedClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-closed-left.js';
 
 
 

 
 export const ObiTwowayStackedClosedLeft = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-closed-left',
   elementClass: ObiTwowayStackedClosedLeftElement,
   events: {
     
   }
  });
 
 